import { useEffect, useState } from "react";
import Base from "../../Base/views/Base";
import Box from '@mui/material/Box';
import { Button, Card, Grid, IconButton, TextField, Typography, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import room from "../../assets/room.jpg";
import DeleteIcon from '@mui/icons-material/Delete';
import Popup from "../../components/Popup";
import Swal from "sweetalert2";
import axiosInstance from "../../../axiosInstance";

const RoomLandingPage = () => {
    const [hotelID] = useState(localStorage.getItem("billing_app_hotel"));
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);

    const initialValues = {
        no: "",
        name: "",
        type: "",
        capacity: "",
        status: "",
        hotel: ""
    };

    const [inputData, setInputData] = useState(initialValues);
    const [errors, setErrors] = useState(initialValues);

    useEffect(() => {
        getData();
        //eslint-disable-next-line
    }, []);

    const getData = () => {
        axiosInstance(`/api/room/?hotel=${hotelID}`, {
            method: "GET"
        }).then(res => {
            setData(res.data);
        }).catch(err => {
            console.log(err);
        });
    };

    const validate = (fieldValues = inputData) => {
        let temp = { ...errors };

        if ("no" in fieldValues)
            temp.no = fieldValues.no ? "" : "Room No is required";

        if ("capacity" in fieldValues)
            temp.capacity = fieldValues.capacity ? "" : "Capacity is required";

        if ("type" in fieldValues)
            temp.type = fieldValues.type ? "" : "Type is required";

        if ("status" in fieldValues)
            temp.status = fieldValues.status ? "" : "Status is required";

        setErrors({ ...temp });
        return Object.values(temp).every((x) => x === "");
    };

    const handleChange = (e) => {
        setInputData({ ...inputData, [e.target.name]: e.target.value });
    };

    const handleClose = () => {
        setOpen(false);
        setInputData(initialValues);
        setErrors(initialValues);
    };

    const handleSubmit = () => {
        let api = inputData?.id ? `/api/room/${inputData.id}/` : `/api/room/`;
        let method = inputData?.id ? "PUT" : "POST";
        if (validate(inputData)) {
            axiosInstance(api, {
                method: method,
                data: {
                    no: inputData.no,
                    name: inputData.name,
                    capacity: inputData.capacity,
                    type: inputData.type,
                    status: inputData.status,
                    hotel: hotelID
                }
            }).then(res => {
                getData();
                setInputData(initialValues);
                setErrors(initialValues);
                setOpen(false);
            }).catch(err => {
                console.log(err);
            });
        }
    };

    const handleClick = (res) => {
        setOpen(true);
        setInputData(res);
    };

    const handleDelete = (e, id) => {
        e?.stopPropagation();
        Swal.fire({
            title: "Are you sure?",
            text: "Are you sure want to delete this Room?",
            showCancelButton: true,
            confirmButtonText: "Delete Room",
            icon: 'warning',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance(`/api/room/${id}/`, {
                    method: "DELETE"
                }).then(res => {
                    getData();
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Room has been deleted successfully',
                        timer: 1500
                    });
                }).catch(err => {
                    console.log(err);
                });
            }
        });
    };

    return (
        <Base>
            <Popup
                open={open}
                handleClose={handleClose}
                title={"Add Room"}
                handleSubmit={handleSubmit}
                maxWidth="sm"
            >
                <Box sx={{ mt: 2, mb: 2 }}>
                    <TextField
                        label="Room No"
                        fullWidth
                        required
                        name="no"
                        onChange={handleChange}
                        value={inputData?.no || ""}
                        size="small"
                        sx={{ mt: 2, width: "100%" }}
                        {...(errors.no && {
                            error: true,
                            helperText: errors.no,
                        })}
                    />
                    <TextField
                        label="Room Name"
                        fullWidth
                        // required
                        name="name"
                        onChange={handleChange}
                        value={inputData?.name || ""}
                        size="small"
                        sx={{ mt: 2, width: "100%" }}
                        {...(errors.name && {
                            error: true,
                            helperText: errors.name,
                        })}
                    />
                    <TextField
                        label="Capacity"
                        type="number"
                        fullWidth
                        required
                        name="capacity"
                        onChange={handleChange}
                        value={inputData?.capacity || ""}
                        size="small"
                        sx={{ mt: 2, width: "100%" }}
                        {...(errors.capacity && {
                            error: true,
                            helperText: errors.capacity,
                        })}
                    />
                    <FormControl fullWidth size="small" sx={{ mt: 2 }} error={Boolean(errors.type)}>
                        <InputLabel>Type *</InputLabel>
                        <Select
                            name="type"
                            value={inputData?.type || ""}
                            onChange={handleChange}
                            label="Type"
                        >
                            <MenuItem value="AC">AC</MenuItem>
                            <MenuItem value="Non-AC">Non-AC</MenuItem>
                        </Select>
                        {errors.type && <Typography color="error" variant="caption">{errors.type}</Typography>}
                    </FormControl>
                    <FormControl fullWidth size="small" sx={{ mt: 2 }} error={Boolean(errors.status)}>
                        <InputLabel>Status</InputLabel>
                        <Select
                            name="status"
                            value={inputData?.status || ""}
                            onChange={handleChange}
                            label="Status"
                        >
                            <MenuItem value="free">Free</MenuItem>
                            <MenuItem value="occupied">Occupied</MenuItem>
                        </Select>
                        {errors.status && <Typography color="error" variant="caption">{errors.status}</Typography>}
                    </FormControl>
                </Box>
            </Popup>

            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mb: 2 }}>
                <Button 
                    variant="contained" 
                    onClick={() => setOpen(true)}
                    size="small"
                    sx={{ 
                        borderRadius: 1.5,
                        px: 2,
                        py: 0.75,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(139, 68, 255, 0.3)',
                        '&:hover': {
                            boxShadow: '0 4px 12px rgba(139, 68, 255, 0.4)',
                            transform: 'translateY(-1px)',
                        },
                        transition: 'all 0.3s ease',
                    }}
                >
                    Add Room
                </Button>
            </Box>

            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    {data?.map((res) => (
                        <Grid item xs={12} sm={6} md={4} key={res.id}>
                            <Card
                                variant="outlined"
                                sx={{ 
                                    width: "100%", 
                                    maxWidth: 320, 
                                    display: "flex", 
                                    mt: 1.5, 
                                    p: 1.5, 
                                    cursor: "pointer", 
                                    borderRadius: 2,
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
                                    border: '1px solid rgba(0, 0, 0, 0.08)',
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    "&:hover": {
                                        boxShadow: '0 4px 12px rgba(139, 68, 255, 0.15)',
                                        transform: "translateY(-3px)",
                                        borderColor: "primary.main",
                                    },
                                }}
                                onClick={() => handleClick(res)}
                            >
                                <Grid container>
                                    <Grid item xs={3}>
                                        <img src={res?.image || room} alt="room" style={{ width: "100%" }} />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Box sx={{ ml: 2 }}>
                                            <Typography variant="subtitle2">Room No: <strong>{res?.no}</strong></Typography>
                                            <Typography variant="subtitle2">Room Name: <strong>{res?.name}</strong></Typography>
                                            <Typography variant="body2" sx={{ mt: 0.5 }}>Capacity: <strong>{res?.capacity}</strong></Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <IconButton onClick={(e) => handleDelete(e, res?.id)}><DeleteIcon color="error" /></IconButton>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box sx={{ ml: 2, mt: 1, display: "flex", justifyContent: "space-between" }}>
                                            <Typography variant="body2">{res?.type}</Typography>
                                            <Typography variant="body2" sx={{ color: res?.status === 'free' ? 'green' : 'red', fontWeight: 'bold' }}>{res?.status}</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {data?.length === 0 && (
                <Box 
                    sx={{ 
                        mt: 8, 
                        textAlign: "center",
                        py: 8,
                    }}
                >
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            color: 'text.secondary',
                            mb: 2,
                            fontWeight: 500,
                        }}
                    >
                        No Rooms yet
                    </Typography>
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            color: 'text.secondary',
                            mb: 4,
                        }}
                    >
                        Create your first room to start managing reservations
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={() => setOpen(true)}
                        sx={{
                            borderRadius: 2,
                            px: 4,
                            py: 1.5,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        Create New Room
                    </Button>
                </Box>
            )}
        </Base>
    );
};

export default RoomLandingPage;